import { ShipmentWaybillGoodsItemListSearchCriteria } from '../../models/shipment-waybill-goods-items.model';

export class ShipmentWaybillGoodsItemsLoad {
  constructor(public payload: ShipmentWaybillGoodsItemListSearchCriteria) {}
  public static readonly type = '[ShipmentWaybillGoodsItems] Goods Items Load';
}

export class ShipmentWaybillGoodsItemsInitialState {
  public static readonly type = '[ShipmentWaybillGoodsItems] Set Initial State';
}
